import { Dialog, DialogContent, Typography } from "@mui/material";
import { fetchAuthSession } from "aws-amplify/auth";
import { BroadcastChannel } from "broadcast-channel";
import React, { Fragment, useEffect, useRef, useState } from "react";
// import IdleTimer from 'react-idle-timer';
// import config from './config.js';

interface Props {
	onLogOut: () => void;
}

/**
 * Shares the session state among tabs
 * @param props
 */
export default function SessionHandler(props: Props) {
	const sessionEventChannel = React.useMemo(
		() => new BroadcastChannel("sessionEvent"),
		[]
	);

	const sessionTimerRef = useRef<any>() as any;
	const idleWarningTimerRef = useRef<any>() as any;

	/**
	 * If the tab / window becomes active verify that the session is still valid
	 */
	const onFocus = async () => {
		try {
			await fetchAuthSession();
		} catch (err) {
			window.location.reload();
		}
	};
	useEffect(() => {
		window.addEventListener("focus", onFocus);
		return () => {
			window.removeEventListener("focus", onFocus);
		};
	});

	useEffect(() => {
		sessionEventChannel.onmessage = (message) => {
			if (message.event === "resetTimer") {
				resetTimer();
			}
			if (message.event === "invalidate") {
				props.onLogOut();
			}
		};
		return () => {
			sessionEventChannel.close();
		};
	}, []);

	const handleIdle = async () => {
		sessionEventChannel.postMessage({ event: "invalidate" });
		props.onLogOut();
	};

	const [showIdleDialog, setShowIdleDialog] = useState(false);
	const handleIdleWarning = () => {
		setShowIdleDialog(true);
	};

	const resetTimer = () => {
		sessionTimerRef.current?.reset();
		setShowIdleDialog(false);
	};

	const handleAction = () => {
		sessionEventChannel.postMessage({ event: "resetTimer" });
	};

	return (
		<Fragment>
			{/* <IdleTimer 
                ref={sessionTimerRef}
                element={document}
                onIdle={handleIdle}
                timeout={config.session.timeout}
                debounce={250}
                onAction={handleAction}
            />
            <IIdleTimerProps
                ref={idleWarningTimerRef}
                element={document}
                onIdle={handleIdleWarning}
                timeout={config.session.timeout - 60000}
            /> */}
			{showIdleDialog && (
				<Dialog open={true} onClose={resetTimer} onMouseMove={resetTimer}>
					<DialogContent>
						<Typography variant="h5">
							Your session is about to expire
						</Typography>
					</DialogContent>
				</Dialog>
			)}
		</Fragment>
	);
}
